import React, { useState } from "react";
import { css } from "emotion";
import { colors, boxStyles, textSizes } from "../styles/theme";

const GenericTextInput = ({
  placeholder,
  value,
  onValueChange,
  style,
  needsCounter = true,
  textOverlay = false,
  isPassword = false,
  type,
  name,
  maxLength = 'none',
}) => {
  const [count, setCount] = useState(value.length);

  const handleChange = (e) => {
    const { value } = e.target;
    setCount(value.length);
    onValueChange(value);
  };

  return (
    <div className={container + ` ${style ? style : ""}`}>
      {isPassword ? (
        <input
          type="password"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          name={name}
          maxLength={maxLength}
        />
      ) : (
        <input
          type={type ? type : "text"}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          name={name}
          maxLength={maxLength}
        />
      )}

      {needsCounter && <p>{textOverlay ? textOverlay : maxLength !== 'none' ? maxLength - count : ''}</p>}
    </div>
  );
};

export default GenericTextInput;

const container = css`
  position: relative;
  width: 100%;
  display: flex;
  input {
    box-sizing: border-box;
    width: 100%;
    background-color: ${colors.inputBackground};
    padding: 10px;
    border: none;
    border-radius: ${boxStyles.borderRadius};
    color: ${colors.inputTextColor};
    font-size: ${textSizes.normal};
  }

  p {
    position: absolute;
    bottom: 3px;
    right: 6px;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
  }

  input:focus {
    outline: none;
  }
`;
